<template>
  <div
    id="app"
    class="min-h-screen w-screen bg-base-100 max-w-full"
  >
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
